/**
 * @flow weak
 */


// Consts
export const ON_YOUR_TICKET_MOUNT = 'ON_YOUR_TICKET_MOUNT';
export const ON_YOUR_TICKET_SUCCESS = 'ON_YOUR_TICKET_SUCCESS';
export const ON_YOUR_TICKET_ERROR = 'ON_YOUR_TICKET_ERROR';

// Actions
export const onYourTicketInit = (id) => {
  return {
    type: ON_YOUR_TICKET_MOUNT,
    id
  };
};



// WEBPACK FOOTER //
// ./src/modules/your-ticket/actions.js